import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const GradientScaleContainer = styled.div(({ min, max }) => ({
  display: "flex",
  flexDirection: "row",
  width: "50%",
  border: "1px solid lightgray",
  borderRadius: "8px",
  height: "1.3rem",

  "&::before": {
    alignSelf: "center",
    content: `'${min}'`,
    fontSize: "0.8rem",
    paddingLeft: "0.8rem",
    paddingRight: "0.8rem",
    whiteSpace: "nowrap",
  },

  "&::after": {
    alignSelf: "center",
    content: `'${max}'`,
    fontSize: "0.8rem",
    paddingLeft: "0.8rem",
    paddingRight: "0.8rem",
    whiteSpace: "nowrap",
  },
}));

export const GradientScale = styled.div(({ background }) => ({
  background: background ? background : "#EEEEEE",
  width: "100%",
  height: "auto",
  borderLeft: "1px solid lightgray",
  borderRight: "1px solid lightgray",
}));

export const HeatmapTitle = styled(Typography)(({ textcolor }) => ({
  color: textcolor,
  fontWeight: 600,
}));

export const HeatmapHeaderContent = styled.div({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "1rem",
  alignItems: "center",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/Heatmap/HeatmapHeader.styles.js